<template>
    <div class="topbar-container up-panel">
        <div class="scrollbar-container">
            <div class="title fz_40">上传并提交您的身份证照片</div>
            <div class="message c_999 fz_24">拍照时确保图像清晰，避免反光影响，以提高识别的正确率。</div>
            <validation-observer class="up-container" v-slot="{ invalid }" ref="form" tag="div">
                <validation-provider
                    rules="required"
                    :customMessages="{required:'请上传本人身份证人像面'}"
                    tag="div"
                    class="up-el r8 shadow"
                >
                    <input type="hidden" v-model="formData.idCardFrontImg" />
                    <div
                        class="img-positive bg-cover img"
                        :style="formData.idCardFrontImg&&{backgroundImage: `url('${formData.idCardFrontImg}')`}"
                        @click="onUpImg('idCardFrontImg')"
                    ></div>
                    <div class="tc c_666 fz_28">
                        点击上传本人身份证
                        <span class="c_warning">人像面</span>
                    </div>
                </validation-provider>
                <validation-provider
                    rules="required"
                    :customMessages="{required:'请上传本人身份证国徽面'}"
                    tag="div"
                    class="up-el r8 shadow mt_24"
                >
                    <input type="hidden" v-model="formData.idCardBackendImg" />
                    <div
                        class="img-back bg-cover img"
                        :style="formData.idCardBackendImg&&{backgroundImage: `url('${formData.idCardBackendImg}')`}"
                        @click="onUpImg('idCardBackendImg')"
                    ></div>
                    <div class="tc c_666 fz_28">
                        点击上传本人身份证
                        <span class="c_warning">国徽面</span>
                    </div>
                </validation-provider>
                <div class="bh bc footBar">
                    <van-button
                        :class="getBtnCls(invalid)"
                        @click="onSaveClick"
                        class="btn btn-goodbuy"
                    >
                        <span class="fz_30 btn-span">立即上传</span>
                    </van-button>
                </div>
            </validation-observer>
        </div>
    </div>
</template>

<script>
import { verificationId } from "@/api/card";
import { user } from "@/mixin/user";
import { mixinValid } from "@/mixin/valid";
import { cuImage } from "@/utils/bridge";
export default {
    mixins: [user, mixinValid],
    name: "CardIdUp",
    data() {
        return {
            formData: {
                idCardFrontImg: "",
                idCardBackendImg: "",
                toastMessage: "正在识别中..."
            },
            // 微信原生功能配置
            wx: {}
        };
    },
    // created() {
    //     if (this.$store.state.isDev) {
    //         this.formData = {
    //             idCardFrontImg:
    //                 "https://www.zzbjr.cn/akfile/view/cos/file/head/20200423/20042314275439903105.jpg",
    //             idCardBackendImg:
    //                 "https://www.zzbjr.cn/akfile/view/cos/file/head/20200423/20042314263778003263.jpg",
    //             toastMessage: "正在识别中..."
    //         };
    //     }
    // },
    methods: {
        // 上传图片
        onUpImg: function(dataName) {
            cuImage(this.wx).then(res => {
                this.formData[dataName] = res;
            });
        },
        onSaveClick() {
            const me = this;
            me.validForm().then(() => {
                verificationId(me.formData).then(res => {
                    me.$store.state.money.isUpId = true;
                    me.$store.state.money.idData = res.data;
                    me.backGo();
                });
            });
        }
    }
};
</script>

<style scoped lang="scss">
@include img-list("~@/assets/imges/card/", "positive", "back");
.title {
    padding-bottom: 5px;
}
</style>
